module.exports = __webpack_public_path__ + "img/bell-green.svg";